import { useMutation } from '@tanstack/react-query';
import { G2StateResponse } from 'app/modules/g2/responses';
import { get } from 'app/shared/utils/fetchr';

export const useGenerateG2State = () => {
  return useMutation({
    mutationFn: () => get<G2StateResponse>('/g2/state'),
  });
};
